import { PREFIX } from '@visactor/vchart';

export const REACT_TOOLTIP_ClASS_NAME = `${PREFIX}_REACT_TOOLTIP`;
